module.exports = __webpack_public_path__ + "static/media/Asset-min.6ffa5007.png";